import { Component } from '@angular/core';
import { ModalService } from '../../services/modal.service';

@Component({
  selector: 'ng-casto-inspiration-tip',
  templateUrl: './inspiration-tip.component.html',
})
export class InspirationTipComponent {
  public currentName: string;
  public currentError: number;
  public isLoading: boolean = false;

  constructor(public modal: ModalService) {}
}
